import { ComponentType } from 'react';

import CustomFormHelperText from './mappedTemplateFormControl/CustomFormHelperText';
import type { AllPlaceholderKeys } from './types';
import type { MappedTemplateFormControlProps, OnChangeFn } from './mappedTemplateFormControl/types';
import { useMappedTemplateFormControlMap } from './mappedTemplateFormControl/useMappedTemplateFormControlMap';

export type { MappedTemplateFormControlProps } from './mappedTemplateFormControl/types';

/**
 * Each Template Form Control component passes back a FieldMetaData object in
 * its change callback. This includes the components _own_  determination of
 * whether the value is empty or valid/ in error. The final fieldError that will
 * be shown may be reflect this directly, but it can be overridden by the parent
 * (i.e. LoadSearchTemplateDialog) which might need to validate multiple fields
 * that interact (e.g. start and end dates within a filter)
 */
export default function MappedTemplateFormControl<K extends AllPlaceholderKeys>({
  filterNameAndField,
  onChange,
  fieldError,
  initialFlatSearchTreeNode,
  initialValue,
}: MappedTemplateFormControlProps<K>) {
  const controlMap = useMappedTemplateFormControlMap({
    filterNameAndField,
    initialFlatSearchTreeNode,
    initialValue,
  });

  const ControlComponent = controlMap[filterNameAndField];

  if (!ControlComponent) {
    return <div>{filterNameAndField}: Not implemented</div>;
  }

  // Could not figure out a way to avoid type assertion, but any parent
  // component will still have correct typing
  const TypedControl = ControlComponent as ComponentType<{ onChildChange: OnChangeFn<K> }>;

  return (
    <>
      <TypedControl onChildChange={onChange} />
      {fieldError && <CustomFormHelperText fieldError={fieldError} />}
    </>
  );
}
